import { Component } from '@angular/core';

@Component({
  selector: 'app-vendoronboard',
  templateUrl: './vendoronboard.component.html',
  styleUrls: ['./vendoronboard.component.css']
})
export class VendoronboardComponent {

  ShowCard:any;
}
